import moment from "moment";
export default function formAPIOrdersFollowUp({
  // appointmentid,
  // doctorid,
  // doctorimage,
  // doctorname,
  // followupdate,
  // imagepath,
  // isfollowup,
  // isfreevisit,
  // specality,

  followupid,
    doctorid,
    isfollowup,
    followupdate,
    isfreevisit,
    isfreevisitbooked,
    appointmentid,
    doctorimage,
    patientname,
    patientfcmtoken,
    patientmobile,
    patientemail,
    specality,
    doctorname,
    imagepath,
    referredby,
    isdoctoractive,
    patientid


}) {
  return Object.freeze({
    // appointmentid,
    // doctorid,
    // doctorimage,
    // doctorname,
    // followupdate,
    // imagepath,
    // isfollowup,
    // isfreevisit,
    // specality,
    followupid,
    doctorid,
    isfollowup,
    followupdate,
    isfreevisit,
    isfreevisitbooked,
    appointmentid,
    doctorimage,
    patientname,
    patientfcmtoken,
    patientmobile,
    patientemail,
    specality,
    doctorname,
    imagepath,
    referredby,
    isdoctoractive,
    patientid
  });
}